import { defineStore } from 'pinia'
import {computed, ref} from "vue";

export const useProposalOldStore = defineStore('proposalOld', () => {
    const proposal = ref(null);
    const activities = ref(null);
    const lodging = ref(null);
    const custom = ref(null);
    const eateries = ref(null);
    const start = ref(null);
    const end = ref(null);
    const days = ref({});

    function setProposal(data) {
        proposal.value = data;
        start.value = new Date(data.start_date);
        end.value = new Date(data.end_date);
        let d = Math.ceil((end.value.getTime() - start.value.getTime()) / (1000 * 3600 * 24)) + 1;
        for (let i = 0; i < d; i++) {
            const date = new Date(start.value.getTime() + (i * 24 * 60 * 60 * 1000))
            const title = date.toLocaleString('default', { weekday: 'long', day: 'numeric', month: 'long' });
            days.value[i] = {
                date: date,
                title: title.charAt(0).toUpperCase() + title.slice(1)
            };
        }
        fetchActivities();
        fetchLodging();
        fetchEateries();
        fetchCustom();
    }
    function fetchActivities() {
        axios.get(route('api.proposal.itinerary.type', {proposal: proposal.value.id, type: 'activity'}))
            .then((response) => {
                activities.value = response.data
            })
    }
    function fetchLodging() {
        axios.get(route('api.proposal.itinerary.type', {proposal: proposal.value.id, type: 'lodging'}))
            .then((response) => {
                lodging.value = response.data
            })
    }
    function fetchEateries() {
        axios.get(route('api.proposal.itinerary.type', {proposal: proposal.value.id, type: 'eatery'}))
            .then((response) => {
                eateries.value = response.data
            })
    }

    function fetchCustom() {
        axios.get(route('api.proposal.itinerary.type', {proposal: proposal.value.id, type: 'custom'}))
            .then((response) => {
                custom.value = response.data
            })
    }
    const proposalReady = computed(() => {
        return proposal.value !== null
    });
    const itineraryReady = computed(() => {
        return activities.value !== null && lodging.value !== null && eateries.value !== null && custom.value !== null
    });

    return {
        proposal,
        activities,
        lodging,
        eateries,
        custom,
        itineraryReady,
        proposalReady,
        start,
        end,
        days,
        setProposal,
        fetchActivities,
        fetchLodging,
        fetchEateries,
        fetchCustom
    }
})
